import { render } from "./SpeedRestrictionRegister.vue?vue&type=template&id=6e0d0d80&scoped=true"
import script from "./SpeedRestrictionRegister.vue?vue&type=script&lang=js"
export * from "./SpeedRestrictionRegister.vue?vue&type=script&lang=js"

import "./SpeedRestrictionRegister.vue?vue&type=style&index=0&id=6e0d0d80&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0d0d80"]])

export default __exports__